module.exports = __webpack_public_path__ + "static/PortfolioHomePage-ec2fd8faa869ddbdff37d0246ebcd78d.jpg";